export const MENU_TOGGLE = "MENU_TOGGLE";
export const MENU_LOAD_ITEMS = "MENU_LOAD_ITEMS";
export const MENU_ALTERA_FORNECEDOR = "MENU_ALTERA_FORNECEDOR";
export const MENU_TOGGLE_DARK_MODE = "MENU_TOGGLE_DARK_MODE";
export const MENU_POPUP = "MENU_POPUP";
export const MENU_ALT_TITLE = "MENU_ALT_TITLE";
export const CLEAR_STATE = "CLEAR_STATE";
